forms-orders-files
  div
    div.mb-5
      forms-orders-files-destroy(tag-scope="{ this.tagScope }.destroy")
    div.mb-5
      forms-orders-files-create(tag-scope="{ this.tagScope }.create")
    script(type="typescript").
      this.mixin('forms.orders.files');